import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { DireccionService } from 'src/app/services/direccion.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { VendedorRubroClienteService } from 'src/app/services/vendedor-rubro-cliente.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalObservacionesComponent } from '../../common/modal-observaciones/modal-observaciones.component';
import * as _ from 'lodash';
import { RutService } from 'src/app/shared/services/rut.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';

@Component({
  selector: 'app-guia-despacho-cabecera',
  templateUrl: './guia-despacho-cabecera.component.html',
  styleUrls: ['./guia-despacho-cabecera.component.scss'],
  providers: [SecurityService],
})
export class GuiaDespachoCabeceraComponent implements OnInit {
  // I/O
  @Input() permiteUnidadNegocio: boolean = false;
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = [];

  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSucursalChange: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalObservacionesComponent, { static: true }) modalObservaciones: ModalObservacionesComponent;

  // Data &  Tmp
  private rutEmpresa: number;
  enableClient: boolean = true;
  private sucursalEmpresa: number;
  clienteSeleccionado: any = null;
  sucursalSeleccionada: any = null;
  vendedorSeleccionado: any = null;
  // optionsCondPago: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsTipoTraslado: Array<any> = [];
  optionsTipoEnvio: Array<any> = [];
  optionsSucursal: Array<any> = [];
  optionsVendedor: Array<any> = [];
  observaciones: string = '';
  optionsCondicionPago: Array<any> = [];
  headerData: any = {};
  ValidateError: boolean = false;
  showBodegaEntrada: boolean = false;
  showBodegaSalida: boolean = false;
  OpTipoMov: number = null;

  // public getters
  get cliente() {
    if (!this.headerData) return null;
    return this.headerData.clienteSeleccionado;
  }
  // Form
  formHeader: FormGroup;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    // private bodegaServ: BodegaService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private direccionService: DireccionService,
    private vendedorRubroClienteService: VendedorRubroClienteService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
    private vendedorService: VendedorService,
    private bodegaService: BodegaService,
    private condicionPagoService: CondicionPagoService
  ) {
    this.log = this.clog.log('GUIA-DESPACHO-CABECERA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    // this.loadBodegas()
    this.fetchCondicionPago();
    this.createForms();
    this.formChangesSubscriptions();
    this.loadBodegas();
    this.loadVendedores();
    this.loadCombosTipoEnvioTipoTraslado();
  }
  private fetchCondicionPago() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      tipobusqueda: 1,
    };

    this.log('fetch condición pago', JSON.stringify(inputParams));
    this.condicionPagoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsCondicionPago = registros.map((condicionPago) => ({
        value: condicionPago.codigo,
        label: condicionPago.descripcion,
        ...condicionPago,
      }));

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago);
    });
  }
  private createForms() {
    this.formHeader = this.fb.group({
      unidad_negocio_codigo: [null, [Validators.required]],
      fechaEmision: [this.datesService.CurrentDateToShortTimeString(), [Validators.required]],
      tipoTraslado: [null, [Validators.required]],
      tipoEnvio: [null, [Validators.required]],
      rutCliente: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      bodegaEntrada: [null],
      bodegaSalida: [null],
      rebajaStock: [false],
      vendedor: [null, [Validators.required]],
      condicionPago: [null, [Validators.required]],
    });
  }

  validate() {
    // this.log('descuento.porcentaje', this.formHeader.get('descuento.porcentaje').valid)
    // this.log('descuento.monto', this.formHeader.get('descuento.monto').valid)
    // this.log('recargo.porcentaje', this.formHeader.get('recargo.porcentaje').valid)
    // this.log('recargo.monto', this.formHeader.get('recargo.monto').valid)

    const unidad_negocio_codigo_state = this.formHeader.get('unidad_negocio_codigo').enabled;
    this.formHeader.get('unidad_negocio_codigo').enable();

    // Add/Remove unidad_negocio_codigo validators
    if (this.permiteUnidadNegocio) {
      this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required]);
    } else {
      this.formHeader.get('unidad_negocio_codigo').setValidators([]);
    }
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity();

    const valid = this.formValidatorsService.validate(this.formHeader);
    if (!unidad_negocio_codigo_state) this.formHeader.get('unidad_negocio_codigo').disable();
    return valid;
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formHeader.get('sucursal').valueChanges.subscribe((sucursal) => {
      this.handleDireccionChange(sucursal);
      this.onSucursalChange.emit(sucursal);
    });

    this.formHeader.get('vendedor').valueChanges.subscribe((vendedor) => {
      this.handleVendedorChange(vendedor);
    });

    this.formHeader.get('tipoTraslado').valueChanges.subscribe((tipoMovimiento: number) => {
      if (tipoMovimiento === null || tipoMovimiento === undefined) return;
      const tipoMovSeleccionado = this.optionsTipoTraslado.filter((p) => p.value === tipoMovimiento)[0];
      if (tipoMovSeleccionado) {
        const { codigo } = tipoMovSeleccionado;
        this.showBodegaEntrada = codigo === 5;
        this.showBodegaSalida = codigo === 5;

        this.formHeader.get('bodegaSalida').setValidators([]);
        if (this.showBodegaSalida) {
          this.formHeader.get('bodegaSalida').setValidators([Validators.required]);
        } else {
          this.formHeader.get('bodegaSalida').setValidators([]);
        }
        if (this.showBodegaEntrada) {
          this.formHeader.get('bodegaEntrada').setValidators([Validators.required]);
        } else {
          this.formHeader.get('bodegaEntrada').setValidators([]);
        }
        this.formHeader.get('bodegaEntrada').updateValueAndValidity();
        this.formHeader.get('bodegaSalida').updateValueAndValidity();

        if (codigo === 5) {
          this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.rutEmpresa));
          this.modalSeleccionarCliente.searchByRut(this.rutEmpresa.toString());
        }
        // else {
        //   // this.vendedorSeleccionado = null;
        //   // this.formHeader.get('rutCliente').setValue(null);
        // }
      }
    });
  }

  private loadBodegas() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
    };

    this.bodegaService.ObtenerBodegas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({
        value: bodega.codigo,
        label: bodega.nombre,
        ...bodega,
      }));
    });
  }

  private loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({
        value: vendedor.codigo,
        label: vendedor.nombre,
        ...vendedor,
      }));

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);
    });
  }

  private loadCombosTipoEnvioTipoTraslado() {
    this.queryTipoEnvioTipoTraslado(({ tipoEnvio, tipoTraslado }) => {
      console.log('tipoEnvio, tipoTraslado', tipoEnvio, tipoTraslado);
      // Tipo envio
      const { registros: registrosTipoEnvio } = tipoEnvio.respuesta;
      this.optionsTipoEnvio = registrosTipoEnvio.map((tipo) => ({
        value: tipo.codigo,
        label: tipo.nombre,
        ...tipo,
      }));

      // Tipo Traslado
      const { registros: registrosTipoTraslado } = tipoTraslado.respuesta;
      this.optionsTipoTraslado = registrosTipoTraslado.map((tipo) => ({
        value: tipo.codigo,
        label: tipo.nombre,
        ...tipo,
      }));
    });
  }

  private queryTipoEnvioTipoTraslado(callback: Function) {
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          {
            tipo_envio {
              obtenerTodos {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                    descripcion
                  }
                }
              }
            }
            tipo_traslado {
              obtenerTodos {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                    descripcion
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const tipoEnvio = response.data.tipo_envio.obtenerTodos;
        const tipoTraslado = response.data.tipo_traslado.obtenerTodos;

        callback({
          tipoEnvio,
          tipoTraslado,
        });
      }
    );
  }

  onClienteSeleccionado({ data }) {
    // this.cleanClientDataAndRelated()
    this.headerData = {};
    this.headerData.clienteSeleccionado = data;
    this.headerData.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.headerData.clienteSeleccionado.rut);
    this.clienteSeleccionado = data;
    this.onClienteChange.emit(this.clienteSeleccionado);
    this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut));
    this.fetchSucursal(this.clienteSeleccionado.rut);
  }

  cleanClientDataAndRelated() {
    this.optionsSucursal = [];
    this.formHeader.get('rutCliente').setValue(null);
    this.formHeader.get('sucursal').setValue(null);
    this.formHeader.get('vendedor').setValue(null);
    this.formHeader.get('condicionPago').setValue(null);

    this.formHeader.get('rutCliente').markAsPristine();
    this.formHeader.get('sucursal').markAsPristine();
    this.formHeader.get('vendedor').markAsPristine();
    this.formHeader.get('condicionPago').markAsPristine();

    this.formHeader.get('rutCliente').markAsUntouched();
    this.formHeader.get('sucursal').markAsUntouched();
    this.formHeader.get('vendedor').markAsUntouched();
    this.formHeader.get('condicionPago').markAsUntouched();

    // this.optionsVendedor = []
    this.sucursalSeleccionada = null;
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null;
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams: any = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut,
    };

    this.log('fecth sucursal', JSON.stringify(inputParams));

    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map((direccion) => ({
        value: direccion.codigo,
        label: direccion.direccion_completa,
        ...direccion,
      }));

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal);
      this.handleDireccionChange(this.formHeader.get('sucursal').value);
      this.onSucursalChange.emit(this.formHeader.get('sucursal').value);
    });
  }

  private handleDireccionChange(value) {
    if (!this.headerData || !this.headerData.clienteSeleccionado || !this.optionsSucursal) return;

    this.headerData.direccion = this.optionsSucursal.filter((p) => p.value === value)[0];
    console.log(this.headerData);

    this.sucursalSeleccionada = this.optionsSucursal.filter((p) => p.value === value)[0];

    if (this.clienteSeleccionado && this.sucursalSeleccionada) this.fetchVendedor(this.clienteSeleccionado.rut, this.sucursalSeleccionada.codigo);

    const condicionPagoSucursal = this.optionsCondicionPago.filter((p) => p.codigo === this.headerData.direccion.condicion_pago_codigo);
    if (condicionPagoSucursal && condicionPagoSucursal.length > 0) this.formHeader.get('condicionPago').setValue(condicionPagoSucursal[0].value);
  }

  private handleVendedorChange(value) {
    this.vendedorSeleccionado = this.optionsVendedor.filter((p) => p.value === value)[0];
  }

  private fetchVendedor(rut, codigo_direccion) {
    const inputParams: any = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa,
      rutCliente: rut,
      direccionCodigo: codigo_direccion,
    };

    this.log('fetch vendedor', JSON.stringify(inputParams));
    this.vendedorRubroClienteService.GetByCliente(inputParams, ({ registros }) => {
      const _cobradores: any[] = registros.filter((p) => p.es_cobrador);
      if (_cobradores && _cobradores.length > 0) {
        const vendedorCobradorSucursal = this.optionsVendedor.filter((p) => p.codigo === _cobradores[0].vendedor_codigo);
        if (vendedorCobradorSucursal && vendedorCobradorSucursal.length > 0) this.formHeader.get('vendedor').setValue(vendedorCobradorSucursal[0].codigo);
      }
      // this.optionsVendedor = registros.map(vendedor => ({
      //   value: vendedor.vendedor_codigo,
      //   label: vendedor.nombreVendedor,
      //   ...vendedor
      // }))
      // this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor)
    });
  }

  // private fetchVendedor({ rut, codigo_direccion }) {
  //   const inputParams: any = {
  //     rutEmpresa: this.rutEmpresa,
  // //     sucursalCodigo: this.sucursalEmpresa,
  //     rutCliente: rut,
  //     direccionCodigo: codigo_direccion
  //   }

  //   this.vendedorRubroClienteService.GetByCliente(inputParams, ({ registros }) => {
  //     this.optionsVendedor = registros.map(vendedor => ({
  //       value: vendedor.vendedor_codigo,
  //       label: vendedor.nombreVendedor,
  //       ...vendedor
  //     }))
  //   })
  // }

  // showModalSeleccionDocumento() {
  //   this.modalSeleccionarDocumento.show()
  // }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  showModalObservaciones() {
    this.modalObservaciones.show();
  }

  saveObservaciones({ data: observaciones }) {
    this.observaciones = observaciones;
  }

  disableHeader(tipo: 'LIBRE' | 'NORMAL') {
    this.enableClient = false;
    this.formHeader.get('fechaEmision').disable();
    this.formHeader.get('tipoTraslado').disable();
    this.formHeader.get('tipoEnvio').disable();
    this.formHeader.get('bodegaSalida').disable();
    this.formHeader.get('bodegaEntrada').disable();

    this.formHeader.get('rutCliente').disable();
    this.formHeader.get('sucursal').disable();

    this.formHeader.get('rebajaStock').disable();
    this.formHeader.get('condicionPago').disable();

    // if (tipo === 'NORMAL')
    this.formHeader.get('unidad_negocio_codigo').disable();
    this.formHeader.get('vendedor').disable();
  }

  enableContent() {
    this.enableClient = true;
    this.formHeader.get('sucursal').enable();
    this.formHeader.get('bodegaSalida').enable();
    this.formHeader.get('tipoEnvio').enable();
    this.formHeader.get('tipoTraslado').enable();
    this.formHeader.get('fechaEmision').enable();
    this.formHeader.get('rutCliente').enable();
    this.formHeader.get('vendedor').enable();
    this.formHeader.get('rebajaStock').enable();
    this.formHeader.get('condicionPago').enable();
    this.formHeader.get('bodegaEntrada').enable();
    this.formHeader.get('unidad_negocio_codigo').enable();
  }

  getHeaderData() {
    const headerData = {
      cliente: this.clienteSeleccionado,
      form: this.formHeader.value,
      sucursal: this.optionsSucursal.filter((p) => p.value === this.formHeader.get('sucursal').value)[0],
      vendedor: this.vendedorSeleccionado,
      condicionPago: this.formHeader.get('condicionPago').value,
      codigo_bodega_salida: this.formHeader.get('bodegaSalida').value,
      codigo_bodega_entrada: this.formHeader.get('bodegaEntrada').value,
      observaciones: this.observaciones,
      tipo_traslado_codigo: this.formHeader.get('tipoTraslado').value,
      unidad_negocio_codigo: this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo'),
      codigo_bodega_origen: this.formHeader.get('bodegaSalida').value,
    };
    return _.cloneDeep(headerData);
  }

  public validateForm() {
    this.ValidateError = true;

    const unidad_negocio_codigo_state = this.formHeader.get('unidad_negocio_codigo').enabled;
    this.formHeader.get('unidad_negocio_codigo').enable();

    // Add/Remove unidad_negocio_codigo validators
    if (this.permiteUnidadNegocio) {
      this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required]);
    } else {
      this.formHeader.get('unidad_negocio_codigo').setValidators([]);
    }
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity();

    const valid = this.formValidatorsService.validate(this.formHeader);
    if (!unidad_negocio_codigo_state) this.formHeader.get('unidad_negocio_codigo').disable();
    return valid;
  }

  public clearForm() {
    this.clienteSeleccionado = null;
    this.sucursalSeleccionada = null;
    this.vendedorSeleccionado = null;
    this.optionsSucursal = [];

    this.formValidatorsService.reset(this.formHeader);

    this.formHeader.get('rutCliente').setValue(null);
    this.formHeader.get('tipoTraslado').setValue(null);
    this.formHeader.get('tipoEnvio').setValue(null);

    this.enableContent();
    this.headerData = {};
    // this.optionsCondicionPago = [];
    // this.optionsVendedor = [];
    this.observaciones = '';
    this.modalObservaciones.cleanAll();
    this.ValidateError = false;
    this.formHeader.get('fechaEmision').setValue(this.datesService.CurrentDateToShortTimeString());
    this.loadVendedores();
    this.fetchCondicionPago();
    this.modalSeleccionarCliente.cleanLast();
  }
}
